import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { InvoiceData } from '../models/InvoiceData';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../../../../../../services/login/login.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestResponse } from '../models/Response';

@Injectable({
  providedIn: 'root'
})
export class RFCsService {
  private apiUrl = environment.apiUrl;
  private listrfc: InvoiceData[] = [];
  private listrfc2: InvoiceData[] = [];
  private obj: any;

  public CFDI = [
    { key: 'G01', description: 'Adquisición de mercancias.' },
    { key: 'G02', description: 'Devoluciones, descuentos o bonificaciones.' },
    { key: 'G03', description: 'Gastos en general.' },
    { key: 'I01', description: 'Construcciones.' },
    { key: 'I02', description: 'Mobilario y equipo de oficina por inversiones.' },
    { key: 'I03', description: 'Equipo de transporte.' },
    { key: 'I04', description: 'Equipo de computo y accesorios.' },
    { key: 'I05', description: 'Dados, troqueles, moldes, matrices y herramental.' },
    { key: 'I06', description: 'Comunicaciones telefónicas.' },
    { key: 'I07', description: 'Comunicaciones satelitales.' },
    { key: 'I08', description: 'Otra maquinaria y equipo.' },
    { key: 'D01', description: 'Honorarios médicos, dentales y gastos hospitalarios.' },
    { key: 'D02', description: 'Gastos médicos por incapacidad o discapacidad.' },
    { key: 'D03', description: 'Gastos funerales.' },
    { key: 'D04', description: 'Donativos.' },
    { key: 'D05', description: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)' },
    { key: 'D06', description: 'Aportaciones voluntarias al SAR.' },
    { key: 'D07', description: 'Primas por seguros de gastos médicos.' },
    { key: 'D08', description: 'Gastos de transportación escolarobligatoria.' },
    { key: 'D09', description: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.' },
    { key: 'D10', description: 'Pagos por servicios educativos (colegiaturas)' },
    { key: 'P01', description: 'Por definir.' },
  ];

  constructor(
    private http: HttpClient,
    private login: LoginService,
  ) { }

  public getAllListRFCs = (): Observable<any> => {
    const dataUser = this.login.getDataClientePedido();
    const dataQuery = {
      cliente_id: dataUser.client_number,
      empresa_id: dataUser.almacenPre,
      correo: dataUser.email,
      option: 'getAll'
    };
    return this.http.post(this.apiUrl + 'account/RFCs.php', dataQuery).pipe(
      map(response => response)
    );
  }
  
  public insertNewRFCs = (dataQuery): Observable<RequestResponse> => {
    return this.http.post<RequestResponse>(this.apiUrl + 'account/RFCs.php', dataQuery).pipe(
      map(response => response)
    );
  }

  public deleteRFC = (id: number): Observable<any> => {
    const dataQuery = {
      id,
      option: 'delete'
    };
    return this.http.post(this.apiUrl + 'account/RFCs.php', dataQuery).pipe(
      map(response => response));
  }

  public sendMailInvoice = (invoiceData: InvoiceData) => {
    const dataUser = this.login.getDataClientePedido();
    const dataQuery = {
      dataUsuario: dataUser,
      dataFactura: invoiceData,
      option: 'sendMailFactura'
    };
    return this.http.post<boolean>(this.apiUrl + 'wskb/sendEmailFactura.php', dataQuery).pipe(
      map(res => res)
    ).toPromise();
  }

  /**
   * Metodo para agregar un nuevo RFC a la lista de @listRFC y a la base de datos
   * @param RFC Datos del RFC llenados en el formialrio
   */
  private addNewItemRFC = (RFC: InvoiceData): void => {
    if (RFC) {
      this.changePredetermined(RFC.predetermined);
      RFC.cfdi = this.searchCFDI(RFC);
      this.listRFC = [...this.listrfc2, RFC];
      this.insertNewRFCs(RFC).subscribe(result => {
        if (result.estatus) {

        }
      });
    }
  }

  /**
   * Metodo para buscar la description del CFDI
   * @param RFC Datos del RFC
   * @return la description del CFDI.
   */
  private searchCFDI = (RFC: InvoiceData): string => {
    let cfdi = '';
    this.CFDI.forEach(element => {
      if (element.key === RFC.useCFDI) {
        cfdi = element.description;
      }
    });
    return cfdi;
  }

  /**
   * Metodo para validar si el RFC ya existe,
   * si es así entonces le enviamos un mensaje si lo quiere remplazar
   * @param item Datos del RFC
   */
  public rfcExits = (item: InvoiceData, item2: any): { existe: boolean, contador: number } => {
    let contador = 0;
    let exits = false;
    this.listrfc2 = [];
    this.obj = {};
    item2.forEach(element => {
      if (item.tax_id === element.tax_id) {
        exits = true;
      }
      else {
        this.obj = {
          cfdi: element.cfdi,
          cliente_id: element.cliente_id,
          correo: element.correo,
          cp: element.cp,
          creationDate: element.creationDate,
          email: element.email,
          empresa_id: element.empresa_id,
          id: element.id,
          idAddress: '',
          legal_name: element.legal_name,
          predetermined: element.predetermined,
          tax_id: element.tax_id,
          updateDate: element.updateDate,
          useCFDI: element.useCFDI,
        }
        this.listrfc2.push(this.obj);
      }
      contador++;
    });
    if (exits) {
      return { existe: true, contador };
    } else {
      this.addNewItemRFC(item);
      return { existe: false, contador };
    }
  }

  /**
   * Metodo para cambiar de predetermiado el RFC
   * si es que se selecciono desde el formlario
   * @param result Valor boolean para saber si si se hace el cambio a predeterminado
   */
  private changePredetermined = (result: boolean) => {
    if (result === true) {
      let contador = 0;
      this.listRFC.forEach(element => {
        this.listRFC[contador].predetermined = false;
        contador++;
      });

    }
  }

  public get listRFC(): InvoiceData[] {
    return this.listrfc;
  }

  public set listRFC(value: InvoiceData[]) {
    this.listrfc = value;
  }
}
